import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// Click on primary result pill e.g. one of the frequent collaborators or locations for who question-answer
export const onWhoPrimaryCoordinationPillClick: ({
	resultSection,
	resultTitle,
	...props
}: commonAttributesType & {
	resultSection: string;
	resultTitle: string;
}) => AnalyticsEventPayload = ({
	resultSection,
	resultTitle,
	...props
}: commonAttributesType & {
	resultSection: string;
	resultTitle: string;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
		source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			resultSection,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			resultTitle,
		},
	};
};
